import { DonationsSkeletonRow } from '../donations-skeleton-row';

const DonationsSkeleton = () => (
  <>
    <DonationsSkeletonRow length={3} />
    <DonationsSkeletonRow length={4} />
  </>
);

export default DonationsSkeleton;
